import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

import {
  SignUpPageComponent,
  Props as SignUpPageProps,
} from "../components/auth/sign-up";
import { Footer } from "../components/display/Footer";
import { FullscreenFlexWrapper } from "../components/display/fullscreen-flex-wrapper";
import { HeadNoMenu } from "../components/display/HeadNoMenu";
import { SignUpInput, useSignupMutation } from "../graphql/generated";
import { globalErrorHandler } from "../sentry/global-error-handler";
import { tw } from "../tailwindcss-classnames";

import { useAuth } from "lib/auth";
import { pick } from "lib/pick";

type SubmitHandler = SignUpPageProps["onSubmit"];

function SignUp() {
  const router = useRouter();
  const { setToken } = useAuth();
  const [signUp, { loading }] = useSignupMutation();
  const [errorState, setError] = useState<any>(null);
  const handleSubmit: SubmitHandler = async (data, event) => {
    event.preventDefault();
    try {
      const input: SignUpInput = pick(
        data,
        "email",
        "password",
        "acceptsMarketing",
        "acceptsTerms"
      );
      input.acceptsTerms = true;

      const result = await signUp({
        variables: { input },
      });
      if (result.errors) {
        setError(result.errors);
      } else if (result.data) {
        setToken(result.data.signUp.token);
        if (typeof (window as any).mixpanel !== "undefined") {
          const mixpanel = (window as any).mixpanel;
          mixpanel.identify(result.data.signUp.user.email);
        }
        // window.location.href = userLink(
        //   result.data.signUp.user,
        //   "/onboarding/plans"
        // );
        router.push("otp");
      }
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    router
      .prefetch("/users/[userId]/onboarding/plans")
      .catch(globalErrorHandler);
  }, [router]);

  return (
    <FullscreenFlexWrapper title={"Sign Up"} bg="bg-white">
      <div className={tw("w-full", "flex-1", "flex-shrink-0")}>
        <HeadNoMenu heading={"Sign Up"} bg="bg-white" className="px-12" />
        <SignUpPageComponent
          onSubmit={handleSubmit}
          error={errorState}
          loading={loading}
        />
      </div>
      <Footer className={tw("w-full", "bg-ecru")} />
    </FullscreenFlexWrapper>
  );
}

export default SignUp;
